import axios from 'axios'
import {Message} from 'element-ui'

import store from './store'

//axios全局配置
// http request 拦截器
const instance = axios.create({
  baseURL: localStorage.apiUrl || process.env.VUE_APP_API,
  // 成功消息提示
  successMsg: false,
  // 错误消息提示
  errorMsg: true,
  // 是否需要登录
  needLogin: true,
  // loading
  showLoading: null,
  // headers
  headers: {
  }
});
instance.interceptors.request.use(
  config => {

    // const token = store.state.token;
    const token = localStorage.token;
    config = {
      ...config,
      headers: {
        token,
        ...config.headers,
      }
    };
    if (config.needLogin && !config.headers.token) {
      //跳转到登录页
      store.dispatch("login");
      return Promise.reject("请登录");
    }

    //显示加载中
    store.commit("SET_LOADING", true);

    if (config.headers['Content-Type'] == undefined) {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
      config.transformRequest = [function (data) {
        let ret = ''
        for (let key in data) {
          let item = data[key];
          ret += encodeURIComponent(key) + '=' + encodeURIComponent(item) + '&'
        }
        return ret
      }]
    }

    /*if (config.loading != false) {
      store.commit('loading', config.loading || true)
    }*/

    config.onSuccess = (res) => {

      return Promise.resolve(res);
    }

    config.onFail = (error, res) => {

      return Promise.reject([error, res]);
    }
    return config;


  },
  error => {
    loadingClose();

    Message.error({message: '请求超时!'});
    return Promise.reject(error)
  },
)

// http response 拦截器
instance.interceptors.response.use(
  response => {
    loadingClose();
    if (response.status && response.status == 200) {
      //token过期
      if (response.data.code == 402 || response.data.code==401) {
        Message.error({message: response.data.msg});
        //跳转到登录页
        store.dispatch("login");
        /* let goUrl = response.data.data + '?backUrl=' + encodeURIComponent(location.href);
         location.href = goUrl;*/
        return Promise.reject(response.data.msg)
      } else if (response.data.code == 0) {
        if (response.config.successMsg) {
          console.log('成功');
          Message.success({message: response.data.msg});
        }
        return Promise.resolve(response.data);
      } else {
        console.log('错误');
        Message.error({message: response.data.msg});

        return Promise.reject(response.data.msg)
      }
    }else {
      return Promise.reject(response.data.msg)
    }

  },
  error => {
    loadingClose();

    if (error.response.status == 504 || error.response.status == 404) {
      Message.error({message: '服务器异常'});
    } else if (error.response.status == 403) {
      Message.error({message: '权限不足,请联系管理员!'});
    } else {
      Message.error({message: '未知错误!'});
    }

    // if (error.response) {
    //     switch (error.response.status) {
    //         case 401:
    //             // 401 清除token信息并跳转到登录页面
    //             store.commit(types.LOGOUT)

    //             // 只有在当前路由不是登录页面才跳转
    //             router.currentRoute.path !== 'login' &&
    //                 router.replace({
    //                     path: 'login',
    //                     query: { redirect: router.currentRoute.path },
    //                 })
    //     }
    // }
    // console.log(JSON.stringify(error));//console : Error: Request failed with status code 402
    return Promise.reject(error.response.data)
  },
)

function loadingClose() {
  store.commit('SET_LOADING', false);
}

export default instance
